export default __webpack_public_path__ + "static/media/privateViewIcon.d67061fc.svg";